import { render } from "./Video.vue?vue&type=template&id=0273632e&scoped=true&ts=true"
import script from "./Video.vue?vue&type=script&lang=ts"
export * from "./Video.vue?vue&type=script&lang=ts"

import "./Video.vue?vue&type=style&index=0&id=0273632e&lang=scss"
import "./Video.vue?vue&type=style&index=1&id=0273632e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0273632e"]])

export default __exports__